import { render, staticRenderFns } from "./20210115.vue?vue&type=template&id=b1af81f6&lang=pug&"
var script = {}
import style0 from "./20210115.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1af81f6')) {
      api.createRecord('b1af81f6', component.options)
    } else {
      api.reload('b1af81f6', component.options)
    }
    module.hot.accept("./20210115.vue?vue&type=template&id=b1af81f6&lang=pug&", function () {
      api.rerender('b1af81f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/20210115.vue"
export default component.exports